var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:container"},[_c('client-only',[_c('OrganismTimeTable',{ref:"timetable",attrs:{"isday":_vm.$device.isMobile || _vm.$device.isTablet ? true : false,"days":_vm.$device.isMobile || _vm.$device.isTablet ? [_vm.day] : _vm.days,"times":_vm.times,"timetables":_vm.timetables,"date":_vm.date,"footer":_vm.clubItems}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }